import { Component, OnInit } from '@angular/core';
import {Customer, CustomerService} from '../customer.service';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {NotificationService} from '../notification.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {

  data = new BehaviorSubject<Array<Customer>>([]);
  searchText = new BehaviorSubject<string>('');

  dataToShow: Customer[];

  searchFc = new FormControl();

  changeState = new Map<string, boolean>();

  disableDeletion = true;

  disableEditing = true;

  constructor(private cs: CustomerService, private router: Router, private ns: NotificationService) { }

  changeSelection(id: string, state: boolean) {
    this.changeState.set(id, state);
    this.disableDeletion = true;
    this.disableEditing = true;
    let selectionCount = 0;
    this.changeState.forEach((value, key) => {
      if (value) {
        this.disableDeletion = false;
        selectionCount++;
      }
    });
    if (selectionCount === 1) {
      this.disableEditing = false;
    }
  }

  getSelection(id: string) {
    const value = this.changeState.get(id);
    if (value) {
      return value;
    } else {
      return false;
    }
  }

  getSelectedIds(): Array<string> {
    const returnValue: Array<string> = [];
    this.changeState.forEach((value, key) => {
      if (value) {
        returnValue.push(key);
      }
    });
    return returnValue;
  }

  filterData(t: string, c: Customer[]): Customer[] {
    return c.filter((customer) => {
      for (let i in customer) {
        if (customer.hasOwnProperty(i)) {
          if (customer[i].toString().indexOf(t) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  bulkDelete(ids: Array<string>) {
    let resultObservable: Observable<string> = Observable.from(new Array<string>());
    ids.forEach((id) => {
      resultObservable = resultObservable.concat(this.cs.remove(id));
    });
    resultObservable.subscribe(
      (id) => {
        console.log(`Id ${id} successfully deleted`);
        this.data.next(this.data.getValue().filter((customer) => customer.id !== id));
        this.changeSelection(id, false);
        this.ns.warning(id, 'Deletado com sucesso!');
      },
      (error) => {
        console.log(`error: ${error}`);
        this.ns.error(error.toString(), 'Erro ao deletar');
      }
    );
  }

  editData() {
    const selection = this.getSelectedIds();
    this.router.navigateByUrl('/customers/' + selection[0]);
  }

  ngOnInit() {
    this.cs.getAll().subscribe((customers: Customer[]) => this.data.next(customers));
    this.searchFc.valueChanges.debounceTime(250).subscribe((text) => {
      this.searchText.next(text);
      this.dataToShow = this.filterData(text, this.data.getValue());
    });
    this.data.subscribe((customers: Array<Customer>) => {
      this.dataToShow = this.filterData(this.searchText.getValue(), customers);
    });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/customer/customer.component.ts